(function () {
  var CARD_ID = 'report-issue-card';
  var reportURL = window.location.origin + '/pages/report-issue';

  var cardHTML =
    '<div class="card" id="' + CARD_ID + '" style="margin-bottom: 15px; padding: 15px 20px;">' +
      '<div>' +
        '<div class="card-header">Report an Order Issue</div>' +
        '<div class="card-body">' +
          '<div>Having a problem with your order? Report it here and we\'ll get it resolved.</div>' +
        '</div>' +
        '<div class="card-footer">' +
          '<a href="' + reportURL + '" target="_top" class="btn btn-primary anim-btn anim-btn-shadow" ' +
            'style="text-decoration: none; display: inline-block;">' +
            'Report an Issue' +
          '</a>' +
        '</div>' +
      '</div>' +
    '</div>';

  function tryInject() {
    var container = document.getElementById('reamaze-container');
    if (!container) return;

    var iframe = container.querySelector('iframe');
    if (!iframe) return;

    var iframeDoc;
    try {
      iframeDoc = iframe.contentDocument || iframe.contentWindow.document;
    } catch (e) {
      return;
    }
    if (!iframeDoc) return;

    if (iframeDoc.getElementById(CARD_ID)) return;

    var contentInner = iframeDoc.getElementById('content-inner');
    if (!contentInner) return;

    var cards = contentInner.querySelectorAll('.card');
    if (cards.length === 0) return;

    cards[0].insertAdjacentHTML('beforebegin', cardHTML);
  }

  setInterval(tryInject, 500);
})();
